export const callToActionI18NPl = {
    enjoyedUsingTimepot: "Spodobał Ci się Timepot?",
    createAccount: "Załóż swoje konto już teraz",
    createAccountShort: "Załóż konto",
    or: "lub",
    sendFeedback: "wyślij nam feedback",
    signUpNow: "Załóż konto!",
};
